import { Component, Input, OnInit } from '@angular/core';
import { Messages } from 'src/app/constants/messages';

import { HistoryModel } from 'src/app/model/shared/components/history-list';

@Component({
  selector: 'app-history-list',
  templateUrl: './history-list.component.html',
  styleUrls: ['./history-list.component.css']
})
export class HistoryListComponent implements OnInit {

  @Input() list: HistoryModel[];

  @Input() name: string;
  
  readonly MESSAGES = Messages;

  constructor() { }

  ngOnInit(): void { }

}
